import { atom } from "jotai";
import SectionRecord from "models/view-models/section-record";

const CurrentSectionAtom = atom<SectionRecord | undefined>(undefined);

export default CurrentSectionAtom;
